import React from 'react';
import { FileTypeIcon } from '@/components/Icons/FileTypeIcon';
import type { Attachment } from '@/types/attachment';
import { openAttachment } from '@/utils/attachments';
import {
  formatFileSize,
  getFileExtension,
  getFileNameWithoutExtension,
  getFileType,
} from '@/utils/file';

interface Props {
  attachment: Attachment;
  className?: string;
  onPreview: (attachment: Attachment) => void;
  onDownloaded?: () => void;
}

export const AttachmentRow: React.FC<Props> = ({
  attachment,
  className,
  onPreview,
  onDownloaded,
}) => (
  <button
    type="button"
    title={attachment.name}
    onClick={() => openAttachment({ attachment, onPreview, onDownloaded })}
    className={`flex h-10 min-w-0 cursor-pointer items-center gap-2 text-left ${className}`}
  >
    <FileTypeIcon
      type={getFileType(attachment.name)}
      className="size-10 rounded"
    />
    <div className="flex min-w-0 flex-1 flex-col">
      <span className="text-caption-13 md:text-subhead-14 truncate text-foreground">
        {getFileNameWithoutExtension(attachment.name)}
      </span>
      <span className="text-caption-12 truncate text-subtle-foreground">
        {getFileExtension(attachment.name).toUpperCase()}{' '}
        {formatFileSize(attachment.sizeInBytes)}
      </span>
    </div>
  </button>
);
